/** Forbrug registreret på en sag, mens arbejdet står på. */
export type CaseEntryType =
  | 'Timer'
  | 'Materialer'
  | 'Kørsel'
  | 'Servicevogn og værktøj'
  | 'Maskiner'
  | 'Bortskaffelse'
  | 'Andet'

export const caseEntryTypes: CaseEntryType[] = [
  'Timer',
  'Materialer',
  'Kørsel',
  'Servicevogn og værktøj',
  'Maskiner',
  'Bortskaffelse',
  'Andet',
]

export type CaseEntryUnit = 'stk.' | 'timer' | 'meter' | 'm²' | 'km' | 'fast pris'

export const caseEntryUnits: CaseEntryUnit[] = ['stk.', 'timer', 'meter', 'm²', 'km', 'fast pris']

/**
 * Én linje i "Forbrug på sagen". Gemmes som array på sagsdokumentet
 * (cases/{caseId}.entries). Felterne svarer til en fakturalinje, så de kan
 * kopieres direkte til faktura — og senere videre til Dinero.
 */
export interface CaseEntry {
  id: string
  type: CaseEntryType
  /** ISO-dato (yyyy-mm-dd) for hvornår arbejdet/forbruget fandt sted. */
  date: string
  description: string
  /** Antal — for timer er det antal timer, for kørsel typisk km. */
  quantity: number
  unit: CaseEntryUnit
  /** Salgspris pr. enhed ekskl. moms — for timer er det timeprisen. */
  unitPrice: number
  /** Indkøbspris pr. enhed (kun til internt overblik — kommer ikke på faktura). */
  purchasePrice?: number
  /** Momssats i procent, fx 25. */
  vatRate: number
  /**
   * Sat når linjen er det faktiske forbrug af en materialelinje fra tilbuddet.
   * Tilbuddets estimat ændres aldrig — sammenligningen sker via dette id.
   */
  quoteLineId?: string
  createdAt: string
  updatedAt: string
}
